export const SITE_URL = (process.env.REACT_APP_SITE_URL || 'https://buscadoutor.com.br').replace(/\/$/, '');
export const SEO_IMAGE_WIDTH = 1200;
export const SEO_IMAGE_HEIGHT = 630;

export const absoluteUrl = (pathOrUrl = '/') => {
  if (!pathOrUrl) return SITE_URL;
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;
  return `${SITE_URL}${pathOrUrl.startsWith('/') ? pathOrUrl : `/${pathOrUrl}`}`;
};

export const normalizeCanonicalPath = (path = '/') => {
  const [pathPart, queryPart] = path.split('#')[0].split('?');
  const cleanPath = pathPart || '/';
  const normalizedPath = cleanPath === '/' ? '/' : cleanPath.replace(/\/+$/, '');
  return queryPart ? `${normalizedPath}?${queryPart}` : normalizedPath;
};

export const SEO_IMAGES = {
  home: '/images/seo/buscadoutor-encontre-medicos-clinicas-especialidades.webp',
  doctors: '/images/seo/medicos-especialistas-buscadoutor.webp',
  clinics: '/images/seo/clinicas-saude-buscadoutor.webp',
  blog: '/images/seo/blog-saude-buscadoutor.webp',
  ecosystem: '/images/seo/ecossistema-saude-buscadoutor.webp',
  business: '/images/seo/clinicas-profissionais-buscadoutor.webp',
  about: '/images/seo/sobre-buscadoutor-saude-digital.webp',
  security: '/images/seo/seguranca-privacidade-saude-buscadoutor.webp',
  generic: '/images/seo/buscadoutor-saude-digital-preview.webp',
};

export const SPECIALTY_SEO_IMAGES = {
  cardiologista: '/images/seo/cardiologista-buscadoutor.webp',
  cardiologia: '/images/seo/cardiologista-buscadoutor.webp',
  dermatologista: '/images/seo/dermatologista-buscadoutor.webp',
  dermatologia: '/images/seo/dermatologista-buscadoutor.webp',
  ginecologista: '/images/seo/ginecologista-buscadoutor.webp',
  ginecologia: '/images/seo/ginecologista-buscadoutor.webp',
  dentista: '/images/seo/dentista-buscadoutor.webp',
  odontologia: '/images/seo/dentista-buscadoutor.webp',
  ortopedista: '/images/seo/ortopedista-buscadoutor.webp',
  ortopedia: '/images/seo/ortopedista-buscadoutor.webp',
  tea: '/images/seo/tea-aba-buscadoutor.webp',
  aba: '/images/seo/tea-aba-buscadoutor.webp',
};

export const getSpecialtySeoImagePath = (specialty = '') => {
  const normalized = specialty
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

  const key = Object.keys(SPECIALTY_SEO_IMAGES).find((item) => normalized.includes(item));
  return key ? SPECIALTY_SEO_IMAGES[key] : SEO_IMAGES.doctors;
};

export const getSeoImageUrl = (pathOrUrl = SEO_IMAGES.generic) => absoluteUrl(pathOrUrl);

export const getBlogArticleImagePath = (slug) => `/images/seo/blog/${slug}-buscadoutor.webp`;

export const createOrganizationSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'BuscaDoutor',
  url: SITE_URL,
  description:
    'Plataforma brasileira para encontrar médicos, dentistas, clínicas, especialidades, convênios e informações de atendimento por cidade.',
  logo: {
    '@type': 'ImageObject',
    url: absoluteUrl('/buscadoutor-logo.png'),
  },
  image: absoluteUrl(SEO_IMAGES.home),
  areaServed: {
    '@type': 'Country',
    name: 'Brasil',
  },
  knowsAbout: [
    'busca de médicos',
    'especialidades médicas',
    'clínicas de saúde',
    'convênios médicos',
    'agendamento de consultas',
    'orientação por sintomas',
  ],
});

export const createWebSiteSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'BuscaDoutor',
  url: SITE_URL,
  inLanguage: 'pt-BR',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${SITE_URL}/buscar?specialty_name={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
});

export const createFaqSchema = (items = []) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: items.map((item) => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer,
    },
  })),
});
